var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackoffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4161 8.07916L24.0898 7.70392L21.8375 8.15402L28.1638 8.52853L30.4161 8.07916Z",
    fill: "url(#paint0_linear_15826_21165)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9942 23.9444L19.6681 23.5699L21.7135 24.5748L28.0398 24.9493L25.9942 23.9444Z",
    fill: "url(#paint1_linear_15826_21165)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1492 2.53204L19.8231 2.15717L18.0067 3.8494L24.3328 4.2239L26.1492 2.53204Z",
    fill: "url(#paint2_linear_15826_21165)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1084 27.1196L14.7823 26.7449L16.0658 28.8382L22.3921 29.2131L21.1084 27.1196Z",
    fill: "url(#paint3_linear_15826_21165)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7335 6.63989C17.6247 6.51505 15.5164 6.39003 13.4074 6.26538C13.552 6.2738 13.6975 6.28735 13.8429 6.30657C14.3844 6.37649 14.9022 6.51487 15.3909 6.71384C18.5047 7.97921 20.4438 11.688 19.8722 15.7468C19.2346 20.2733 15.7088 23.5873 11.8823 23.3609L18.2084 23.7354C22.0349 23.962 25.5607 20.648 26.1983 16.1217C26.7696 12.0625 24.8308 8.35372 21.7172 7.08852C21.2288 6.89011 20.7107 6.75136 20.1696 6.68144C20.0236 6.66203 19.8788 6.64849 19.7335 6.63989Z",
    fill: "url(#paint4_linear_15826_21165)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9591 0.374872L13.633 0L12.7368 2.48151L19.0631 2.85638L19.9591 0.374872Z",
    fill: "url(#paint5_linear_15826_21165)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8278 29.7207L9.50195 29.346L11.6563 29.6251L17.9822 30L15.8278 29.7207Z",
    fill: "url(#paint6_linear_15826_21165)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6477 27.0995L9.32166 26.7252L9.50194 29.346L15.8278 29.7207L15.6477 27.0995Z",
    fill: "url(#paint7_linear_15826_21165)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8343 3.25378L10.508 2.87872C11.2311 2.65962 11.9766 2.52234 12.7368 2.4817L19.0631 2.85639C18.3029 2.89685 17.5574 3.03358 16.8343 3.25378ZM13.6095 26.149L7.28412 25.7746C7.73403 26.0547 8.20629 26.2982 8.69885 26.4986C8.9035 26.5815 9.11085 26.6573 9.32182 26.725L15.6479 27.0993C15.4372 27.0318 15.2296 26.9564 15.0256 26.8736C14.5322 26.6732 14.0601 26.4294 13.6095 26.149ZM13.7675 4.79537L7.44049 4.4205C6.79111 4.89238 6.18032 5.44023 5.6212 6.05598L11.948 6.43067C12.5062 5.81528 13.1172 5.26725 13.7675 4.79537ZM9.7767 21.8454L3.45015 21.4706C3.81906 22.2055 4.25634 22.8877 4.75251 23.5095L11.0784 23.8844C10.5827 23.2626 10.1454 22.5802 9.7767 21.8454ZM9.86605 9.51531L3.53996 9.14081C3.16563 9.90702 2.852 10.7221 2.61531 11.5773L8.9414 11.9523C9.17832 11.0966 9.49172 10.2819 9.86605 9.51531ZM8.40462 15.7563L2.07807 15.3818C2.07108 16.2679 2.14802 17.1326 2.29626 17.9671L8.62258 18.3418C8.47434 17.5075 8.3974 16.6432 8.40462 15.7563Z",
    fill: "url(#paint8_linear_15826_21165)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0787 23.8843L4.75278 23.5095L3.77917 25.9575L10.1053 26.3325L11.0787 23.8843Z",
    fill: "url(#paint9_linear_15826_21165)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1053 26.3326L3.77917 25.9575L5.46691 27.4685L11.7932 27.8428L10.1053 26.3326Z",
    fill: "url(#paint10_linear_15826_21165)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90373 5.42448L3.57673 5.04924L2.18909 7.10701L8.5154 7.4817L9.90373 5.42448Z",
    fill: "url(#paint11_linear_15826_21165)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5154 7.4817L2.18909 7.10701L3.53996 9.1408L9.86605 9.51531L8.5154 7.4817Z",
    fill: "url(#paint12_linear_15826_21165)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75747 19.9584L0.431152 19.5838L1.20056 21.9196L7.52688 22.2943L6.75747 19.9584Z",
    fill: "url(#paint13_linear_15826_21165)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62256 18.3418L2.29624 17.9671L0.431152 19.5838L6.75747 19.9585L8.62256 18.3418Z",
    fill: "url(#paint14_linear_15826_21165)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9414 11.9525L2.61531 11.5775L0.358521 11.93L6.68439 12.3045L8.9414 11.9525Z",
    fill: "url(#paint15_linear_15826_21165)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32655 14.843L0 14.4683L2.07809 15.3818L8.40463 15.7563L6.32655 14.843Z",
    fill: "url(#paint16_linear_15826_21165)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6844 12.3045L0.358533 11.93L0 14.4683L6.32655 14.843L6.6844 12.3045Z",
    fill: "url(#paint17_linear_15826_21165)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68439 12.3045L8.9414 11.9523C9.17832 11.0964 9.4915 10.2817 9.86605 9.51531L8.51541 7.4817L9.90373 5.42448L11.9482 6.43085C12.5064 5.81546 13.1174 5.26743 13.7675 4.79555L13.5042 2.187L15.55 1.16013L16.8341 3.25378C17.5572 3.03358 18.3029 2.89703 19.0629 2.85639L19.9591 0.374878L22.1146 0.652554L22.2944 3.27556C22.5085 3.3442 22.7193 3.4209 22.926 3.50509C23.4158 3.70406 23.8858 3.94531 24.3328 4.22409L26.1491 2.53204L27.8371 4.0405L26.8633 6.49126C27.3606 7.11086 27.7954 7.79471 28.164 8.52871L30.4163 8.07934L31.1846 10.4168L29.3191 12.0334C29.468 12.8676 29.5449 13.7323 29.5363 14.6163L31.6165 15.5327L31.2579 18.0682L29.0009 18.4231C28.7638 19.2779 28.4517 20.0915 28.0751 20.857L29.4276 22.8917L28.0399 24.9493L25.9946 23.9446C25.4366 24.558 24.826 25.1064 24.1762 25.5777L24.4363 28.1873L22.3923 29.2133L21.1087 27.1196C20.3851 27.3413 19.6394 27.4788 18.8799 27.5172L17.9823 30L15.8277 29.7207L15.6477 27.0995C15.4369 27.032 15.2294 26.9566 15.0254 26.8738C14.5322 26.6734 14.0601 26.4296 13.6095 26.1492L11.7932 27.843L10.1054 26.3327L11.0786 23.8845C10.5827 23.2627 10.1454 22.5804 9.7767 21.8456L7.52668 22.2943L6.7575 19.9585L8.62259 18.3418C8.47434 17.5075 8.3974 16.6432 8.40462 15.7563L6.32654 14.843L6.68439 12.3045ZM11.744 14.2519C11.172 18.3125 13.1111 22.0219 16.2249 23.2871C16.7138 23.4855 17.231 23.6237 17.7725 23.694C21.7637 24.2109 25.5368 20.8193 26.1983 16.1213C26.7696 12.0622 24.8308 8.35335 21.7172 7.08816C21.2287 6.88974 20.7107 6.751 20.1696 6.68107C16.1779 6.16398 12.4062 9.55393 11.744 14.2519Z",
    fill: "url(#paint18_linear_15826_21165)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9428 29.6367L15.7634 27.0316L15.6921 27.0085C15.487 26.943 15.2808 26.8678 15.0798 26.7863C14.6043 26.5932 14.1346 26.3527 13.6835 26.0717L13.5942 26.0155L11.7914 27.696L10.2422 26.3089L11.2117 23.8701L11.1806 23.8313C10.6862 23.2115 10.2512 22.5313 9.88883 21.8086L9.84934 21.7303L7.61331 22.1766L6.89173 19.9859L8.7505 18.3742L8.74261 18.3277C8.59166 17.483 8.51878 16.6181 8.52555 15.7569V15.6983L6.45581 14.7884L6.79516 12.3872L9.04157 12.0362L9.05849 11.9736C9.28932 11.1426 9.59866 10.3276 9.97818 9.55136L9.99893 9.50926L8.65258 7.48169L9.94862 5.56047L11.9802 6.56062L12.0454 6.4885C12.5953 5.88208 13.2014 5.33716 13.848 4.86784L13.892 4.83563L13.6301 2.23898L15.5015 1.2996L16.7747 3.37586L16.8769 3.34511C17.6021 3.12472 18.3404 2.99293 19.071 2.95376L19.1549 2.94955L20.045 0.484879L21.9995 0.736745L22.1784 3.34383L22.2502 3.36652C22.4578 3.43278 22.6669 3.50911 22.8725 3.59258C23.3467 3.78551 23.8138 4.02401 24.2594 4.30169L24.3488 4.3577L26.1505 2.67883L27.7008 4.0641L26.7306 6.50498L26.7617 6.54415C27.2493 7.15203 27.6841 7.83222 28.0521 8.56531L28.0911 8.64365L30.3297 8.19684L31.0506 10.3897L29.1916 12.0007L29.1999 12.0471C29.3511 12.8959 29.4235 13.7599 29.4161 14.6156L29.4156 14.6742L31.4869 15.5865L31.1478 17.9856L28.9007 18.3389L28.8836 18.4013C28.6523 19.2347 28.343 20.0487 27.9634 20.8208L27.942 20.8629L29.2897 22.891L27.9939 24.8122L25.9625 23.8146L25.8971 23.8867C25.3452 24.4935 24.7382 25.0381 24.0949 25.5046L24.051 25.537L24.3102 28.1352L22.4413 29.0738L21.1678 26.9964L21.066 27.0281C20.3377 27.2511 19.5999 27.3821 18.8722 27.4195L18.7878 27.4235L17.8966 29.8904L15.9428 29.6367ZM20.1888 6.58442C18.6757 6.38856 17.1481 6.73323 15.7709 7.58182C13.5709 8.93634 12.0206 11.4259 11.6246 14.2407C11.0529 18.2986 12.922 22.0545 16.1709 23.3744C16.462 23.4926 16.7641 23.5895 17.0692 23.6634C17.2932 23.718 17.5236 23.7602 17.7533 23.7903C19.2657 23.9863 20.7935 23.6411 22.1703 22.7929C24.3711 21.438 25.9212 18.9479 26.3181 16.1321C26.8804 12.1398 24.9679 8.29935 21.7711 7.00066C21.4785 6.88204 21.1764 6.78467 20.8709 6.71072C20.6475 6.65672 20.4176 6.61407 20.1888 6.58442Z",
    fill: "url(#paint19_linear_15826_21165)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 2.18681L7.1781 1.81285L7.44051 4.42048L13.7675 4.79535L13.5042 2.18681Z",
    fill: "url(#paint20_linear_15826_21165)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.55 1.15994L9.22415 0.785065L7.1781 1.81285L13.5042 2.18681L15.55 1.15994Z",
    fill: "url(#paint21_linear_15826_21165)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15826_21165",
    x1: 30.0542,
    y1: 9.06602,
    x2: 22.5212,
    y2: 6.29667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#87888A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15826_21165",
    x1: 27.9316,
    y1: 25.2456,
    x2: 20.11,
    y2: 22.3701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#87888A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15826_21165",
    x1: 25.5952,
    y1: 4.04085,
    x2: 18.8488,
    y2: 1.56065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#87888A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15826_21165",
    x1: 22.499,
    y1: 28.9248,
    x2: 14.9957,
    y2: 26.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#87888A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15826_21165",
    x1: 18.271,
    y1: 23.8688,
    x2: 19.6437,
    y2: 6.63083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0154,
    stopColor: "#6E6D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#5E5E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0826,
    stopColor: "#595859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0853,
    stopColor: "#5A595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1771,
    stopColor: "#6B6B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2724,
    stopColor: "#767677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#797A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5541,
    stopColor: "#929293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#BFC0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6954,
    stopColor: "#CDCED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7263,
    stopColor: "#C4C5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7763,
    stopColor: "#ADADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8391,
    stopColor: "#878788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    stopColor: "#535152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9284,
    stopColor: "#464445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15826_21165",
    x1: 19.3244,
    y1: 2.14751,
    x2: 13.6157,
    y2: 0.0488424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#87888A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15826_21165",
    x1: 17.7472,
    y1: 30.6415,
    x2: 10.0646,
    y2: 27.8172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#666767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15826_21165",
    x1: 16.0686,
    y1: 29.0675,
    x2: 9.36686,
    y2: 26.6037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#87888A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    stopColor: "#747576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9855,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15826_21165",
    x1: 7.63933,
    y1: 26.4937,
    x2: 11.0363,
    y2: 1.75352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0154,
    stopColor: "#6E6D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#5E5E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0826,
    stopColor: "#595859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0853,
    stopColor: "#5A595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1771,
    stopColor: "#6B6B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2724,
    stopColor: "#767677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#797A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5541,
    stopColor: "#929293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#BFC0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6954,
    stopColor: "#CDCED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7263,
    stopColor: "#C4C5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7763,
    stopColor: "#ADADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8391,
    stopColor: "#878788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9118,
    stopColor: "#535152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9284,
    stopColor: "#464445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15826_21165",
    x1: 10.4313,
    y1: 25.6468,
    x2: 4.6724,
    y2: 23.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#666767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15826_21165",
    x1: 11.7848,
    y1: 27.8675,
    x2: 4.11437,
    y2: 25.0476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F9092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15826_21165",
    x1: 9.30543,
    y1: 7.05343,
    x2: 3.05428,
    y2: 4.75532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#959698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#A9A9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15826_21165",
    x1: 9.9598,
    y1: 9.26188,
    x2: 2.41696,
    y2: 6.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#666767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15826_21165",
    x1: 4.09443,
    y1: 19.7839,
    x2: 3.94315,
    y2: 22.0983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#818284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3951,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6126,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8065,
    stopColor: "#666767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#5B5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767779"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15826_21165",
    x1: 8.07917,
    y1: 19.8216,
    x2: 1.26526,
    y2: 17.3166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#9EA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    stopColor: "#8C8E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#707172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535455"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15826_21165",
    x1: 8.59554,
    y1: 12.8951,
    x2: 1.02714,
    y2: 10.1127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    stopColor: "#A1A3A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9E9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15826_21165",
    x1: 8.27963,
    y1: 16.0981,
    x2: 0.458411,
    y2: 13.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#666767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_15826_21165",
    x1: 3.21469,
    y1: 14.6778,
    x2: 3.38395,
    y2: 12.0883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1144,
    stopColor: "#666767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3452,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6038,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#818284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B6B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_15826_21165",
    x1: 13.8084,
    y1: 29.2316,
    x2: 20.8,
    y2: 0.333624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1011,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3479,
    stopColor: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3856,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4468,
    stopColor: "#CFCECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5565,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7596,
    stopColor: "#B7B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_15826_21165",
    x1: 13.8465,
    y1: 29.129,
    x2: 20.787,
    y2: 0.442481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2404,
    stopColor: "#C7C5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4435,
    stopColor: "#ABAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5347,
    stopColor: "#D2D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6074,
    stopColor: "#EAE9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6521,
    stopColor: "#F3F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "#CBCAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_15826_21165",
    x1: 14.0028,
    y1: 4.1571,
    x2: 7.23188,
    y2: 1.66789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#666767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    stopColor: "#757677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6389,
    stopColor: "#7E7F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_15826_21165",
    x1: 15.0988,
    y1: 2.38916,
    x2: 7.93494,
    y2: -0.244512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#959698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#A9A9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackoffice);
export default __webpack_public_path__ + "static/media/backoffice.3df85a9c5c91438864c4ddfc3aaff8db.svg";
export { ForwardRef as ReactComponent };